// API配置文件
// 从环境变量中获取API地址
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'https://api.wanzicloud.com'
const PC_BASE_URL = process.env.VUE_APP_PC_BASE_URL || 'https://pc.wanzicloud.com'
const EBK_BASE_URL = process.env.VUE_APP_EBK_BASE_URL || 'https://ebk.wanzicloud.com'

export default {
  // API基础地址
  API_BASE_URL,
  // PC端地址
  PC_BASE_URL,
  // EBK地址
  EBK_BASE_URL,
  // API完整地址
  getApiUrl(path) {
    console.log(process.env)
    console.log('as',`${API_BASE_URL}${path}`)
    return `${API_BASE_URL}${path}`
  },
  // PC端完整地址
  getPcUrl(path = '') {
    return `${PC_BASE_URL}${path}`
  },
  // EBK完整地址
  getEbkUrl(path = '') {
    return `${EBK_BASE_URL}${path}`
  }
}

